export const LifeBroken = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4.9655L10 6.5L11 8.97412L10 11L11.5 13L10.5 15L11 16.9914L10.5 18.5L11 21C11 21 1 15.1664 1 8.33205C1 5.44058 3.08155 3.60056 5.84254 3.07484C8.60352 2.54912 11 4.9655 11 4.9655Z"
        fill="#525D94"
      />
      <ellipse
        cx="6.28008"
        cy="8.50093"
        rx="3.09359"
        ry="3.54328"
        transform="rotate(34.6532 6.28008 8.50093)"
        fill="white"
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 6.5L11 4.9655C11 4.9655 8.60352 2.54912 5.84254 3.07484C3.08155 3.60056 1 5.44058 1 8.33205C1 13.7096 7.19104 18.4675 9.83051 20.2516C10.5456 20.7349 11 21 11 21L10.5 18.5L11 16.9914L10.5 15L11.5 13L10 11L11 8.97412L10 6.5ZM9.90493 8.93336L8.87738 6.39108L9.67925 5.16061C9.47834 5.012 9.23598 4.84834 8.96132 4.69174C8.11591 4.20971 7.078 3.85756 6.02959 4.05719C3.59463 4.52083 2 6.05505 2 8.33205C2 11.2961 4.205 14.2061 6.67907 16.4948C7.69176 17.4317 8.70752 18.2259 9.54676 18.8328L9.46752 18.4366L9.95928 16.9528L9.43988 14.8842L10.3292 13.1056L8.8313 11.1084L9.90493 8.93336Z"
        fill="#28367B"
      />
      <path
        d="M14.0791 9.96518L14.1466 10.1888L14.0183 10.3841L13.0592 11.844L13.3851 13.9795L13.4133 14.1648L13.3128 14.3231L12.3495 15.8389L12.6752 17.923L12.6967 18.0609L12.6438 18.19L11.9716 19.8284L11.9716 21.2086C12.2423 21.0956 12.5849 20.9476 12.9808 20.7656C14.0049 20.2948 15.3806 19.5989 16.791 18.6978C19.646 16.8737 22.4992 14.2996 23.064 11.1593C23.5215 8.61591 22.0111 6.63005 19.5417 5.68329C18.3874 5.24072 17.1691 5.44062 16.1981 5.78437C15.7177 5.95442 15.3129 6.15453 15.0287 6.31201C14.887 6.39055 14.7763 6.45791 14.7022 6.50475C14.6779 6.52018 14.6575 6.53337 14.6414 6.54396L13.4503 7.88076L14.0791 9.96518Z"
        fill="#525D94"
        stroke="#28367B"
      />
      <path
        d="M6.04776 6.53768C6.04776 6.53768 5.02461 6.98836 4.45213 8.46222"
        stroke="white"
        strokeOpacity="0.8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 18C10 18 5.5 15.5 2.5 11C3.5 15.5 10.5 20.5 10.5 20.5L10 18Z"
        fill="#28367B"
        fill-opacity="0.7"
      />
      <path
        d="M12.5 19.0001L12 21.5C12 21.5 18.2871 18.237 20.6766 15.2054C22.945 12.3275 23.7621 8.97752 21.5001 7.00006C21.5001 7.00006 22.7127 8.62268 20.5528 11.8989C18.3929 15.1752 12.5 19.0001 12.5 19.0001Z"
        fill="#28367B"
        fill-opacity="0.7"
      />
      <circle cx="8.5" cy="16.5" r="0.5" fill="#1F2A61" />
      <circle
        cx="16.0959"
        cy="14.9864"
        r="0.5"
        transform="rotate(10.1962 16.0959 14.9864)"
        fill="#1F2A61"
      />
      <circle
        cx="18.2414"
        cy="14.3562"
        r="0.5"
        transform="rotate(10.1962 18.2414 14.3562)"
        fill="#1F2A61"
      />
      <circle
        cx="15.1612"
        cy="17.3585"
        r="1"
        transform="rotate(10.1962 15.1612 17.3585)"
        fill="#1F2A61"
      />
      <circle
        cx="20.1602"
        cy="12.1612"
        r="1"
        transform="rotate(10.1962 20.1602 12.1612)"
        fill="#1F2A61"
      />
    </svg>
  );
};
